import { JSTModalScreen } from "./JSTModalScreen";
import { openModal } from "./openModal";

export default async function openResumeBuilderModal(
  preferFullScreenModal: boolean,
  from: string | null,
): Promise<string | void> {
  const result = await openModal(JSTModalScreen.resumeBuilder(preferFullScreenModal), from);
  return result?.result;
}
